/**
 * Returns the URL to redirect to after authentication.
 * If a pending invite token exists in localStorage, returns the accept-invite URL.
 * Otherwise returns '/dashboard'.
 */
export function getPostAuthRedirect(): string {
  try {
    const token = localStorage.getItem('pendingInviteToken')
    const orgId = localStorage.getItem('pendingInviteOrgId')
    if (token && orgId) {
      return `/accept-invite/${orgId}?token=${token}`
    }
  } catch {
    // Ignore storage errors
  }
  return '/dashboard'
}
